import { useQuery } from '@tanstack/react-query';
import { requestZeusFromBrowser } from 'components/api/zeusBrowserClient';
import type { MarketplaceBrowseVariables } from 'components/marketplace/browse/marketplaceBrowse';

import { MarketplacePriceDistributionDocument } from './__generated__/price-distribution.zeus';
import type { PriceBand } from './priceScale';

/**
 * How many homes sit at each price in the searched area, with the other
 * filters applied and the price filter left out so the whole range shows.
 */
export const usePriceDistribution = (
  listInput: MarketplaceBrowseVariables['listInput'] | undefined,
): PriceBand[] | undefined => {
  const area = listInput?.where;
  const {
    minListPriceCents: _min,
    maxListPriceCents: _max,
    ...attributes
  } = listInput?.filters ?? {};
  const query = useQuery({
    queryKey: ['marketplace', 'price-distribution', area, attributes],
    queryFn: ({ signal }) =>
      requestZeusFromBrowser(
        MarketplacePriceDistributionDocument,
        { input: { area: area!, filters: attributes } },
        signal,
      ),
    enabled: Boolean(area),
    staleTime: 60_000,
    retry: false,
  });
  return query.data?.marketplace.priceDistribution ?? undefined;
};
